module.exports = __webpack_public_path__ + "d57d11f5f7be85401772429094f470c6.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/label-settings/label-settings.html
// module id = 2185
// module chunks = 0